module.exports = __webpack_public_path__ + "static/media/spider.acae3674.svg";